module.exports = __webpack_public_path__ + "static/media/facebook-icon.10ef9b1d.png";